import React, { Component } from 'react';
import '../App.css';
import '../Assets/css/custom.css'

import {Link, Routes,NavLink} from 'react-router-dom';
import axios from 'axios'
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import NavDropdown from 'react-bootstrap/NavDropdown'
import {LinkContainer} from 'react-router-bootstrap'
import logo from '../images/logo.png';
import home from '../images/h.png';
import save from '../images/b.png';
import fd from '../images/f.png';
import lease from '../images/l.png';
import pawn from '../images/p.png';
import profile from '../images/profile.png';
import SimpleReactValidator from 'simple-react-validator';
import { ThemeConsumer } from 'react-bootstrap/esm/ThemeProvider';
import SweetAlert from 'react-bootstrap-sweetalert';
import OTPModal from './OTP';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from 'react-bootstrap/Offcanvas';

const eye = <FontAwesomeIcon icon={faEye} />;
var initPromises = [];
var token = '';
var userDetails ='';
var LOGOUT = 'anonymous/logoutUser?userId=';
var api = require('../Common/Config');
var UserName = '';

var  RESEND_OTP = 'api/resendOTPCode?otpRef=';
var  OTP_REF = 'api/createOTPCode';
var  SEND_OTP = 'api/sendOTPFormAPI';
var  CHANGE_PASSWORD = 'secured/user/changePassword?otpCode='
var GetUser = "";
var getUD = "";

class Header extends React.Component {

  constructor(props) {
    super(props);  
    initPromises.push(this.getToken()); 
    this.validator = new SimpleReactValidator(); 
    this.state = {
      username: '',
      password: '',
      newPassword:'',
      RePassword:'',
      oldPassword:'',
      activeState:true,
      activeState2:false, 
      alertopen:false,
      EnteredOTP:"", 
      Successpop:false,
      ShowPassword:false,
      ShowPassword:false,
      ShowPassword3:false,
      toggle:false,
      width: window.innerWidth,
    }    
  }

  getToken(){
    var getData = sessionStorage.getItem("authData");
    if(getData) {
      var state = JSON.parse(getData);
      token  =  state.token;
      userDetails = state.User;

      var userName = sessionStorage.getItem("userId");
      var userId = JSON.parse(userName);
      UserName =  userId.id;
      
      this.state.isAuthenticated = true;
      this.state.name=state.User.name;
    }
  }
  componentWillMount(){
     GetUser = sessionStorage.getItem("NIC");
     getUD = JSON.parse(GetUser);
     console.log('getUD', getUD)
  }
  Logout(){
    this.logOutAPI()
    var i = sessionStorage.length;
    while(i--) {
      var key = sessionStorage.key(i);
        sessionStorage.removeItem(key);
    }
    this.setState({
      logout:true,
    })
  }


  async logOutAPI() {
    var userName = sessionStorage.getItem("userId");
    var userId = JSON.parse(userName);  
  
      return await axios({
        url:api.HOST+LOGOUT+userId.id,
        method: "GET",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
      }).then((response)=>{
        if(response.data.status===401){
          this.setState({logout:true});
          //this.logOut();
       }
       return response;
      })
      .then((result) => {          
        if(result.data.message=="Logout Success"){
          this.setState({
            Loading:false,
          });
            return console.log(result.data.message);
          }
          this.setState({
            Loading:false,
          });          
          return result;
      }).catch((error)=> {
        console.log(error);
    });
    
  }

  
UserProfile(){  
  
  

    return (

      <Modal
        show={this.state.ProfilePopup}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered 
        backdrop="static"
        onHide={()=>this.setState({ProfilePopup:false})}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <p className='modal-head-f'>USER</p><br/>PROFILE
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>                
          <Form > 
              <Form.Group as={Row} className="mb-1">
                  <Form.Label className="c-font" column sm={5}>
                     Name
                  </Form.Label>
                  <Col sm={7} >
                    {
                      getUD.customerIdType != 3?
                      <Form.Label className="c-font" >
                      {getUD.title} {getUD.UserFirstname}
                      {" "+getUD.UserLastname} 
                       </Form.Label>
                      :
                      <Form.Label className="c-font" >
                      {getUD.companyName}
                       </Form.Label>
                    }
                  </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-1">
                  <Form.Label className="c-font" column sm={5}>
                     {getUD.customerIdType == 1?'ID Number':(getUD.customerIdType == 2?'Passport Number':'BR Number')}
                  </Form.Label>
                  <Col sm={7} >
                  <Form.Label className="c-font" >
                    {getUD.customerIdType == 1?getUD.preferredNIC:getUD.customerId}
                   </Form.Label>
                  </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-1">
                  <Form.Label className="c-font" column sm={5}>
                     Mobile
                  </Form.Label>
                  <Col sm={7} >
                  <Form.Label className="c-font" >
                  {getUD.mobile}
                   </Form.Label>
                  </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-1">
                  <Form.Label className="c-font" column sm={5}>
                     Address
                  </Form.Label>
                  <Col sm={7} >
                  <Form.Label className="c-font" >
                  {getUD.Addressline1 
                  +" "+getUD.Addressline2
                  +" "+(getUD.Addressline3?getUD.Addressline3:'')}
                   </Form.Label>
                  </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-1">
                  <Form.Label className="c-font" column sm={5}>
                     Email
                  </Form.Label>
                  <Col sm={7} >
                  <Form.Label className="c-font" >
                  {getUD.email}
                   </Form.Label>
                  </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-1">
                  <Form.Label className="c-font" column sm={5}>
                     Last Login
                  </Form.Label>
                  <Col sm={7} >
                  <Form.Label className="c-font" >
               
                  {moment(getUD.previousLogin).format('DD/MM/YYYY')
                  +" "+moment(getUD.previousLogin).format('hh:mm:ss A')}
                   </Form.Label>
                  </Col>
              </Form.Group>
              
          </Form>
        </Modal.Body>
         
      </Modal>
    );
}

ConfirmationPopUp() {
  return (
    <Modal
      show={this.state.ComPopup}
    >
      <Modal.Header className='hselect'>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="c-font">Are your sure you want to sign out?</p>
        <div className="d-flex justify-content-end">
          <Button type="button" className="btn-logout" onClick={() => this.setState({ ComPopup: false })}>No</Button>
          <Link to="/"><Button type="submit" className="btn-logout" onClick={() => {this.Logout()}}>Yes</Button></Link>
        </div>
      </Modal.Body>
    </Modal>
  )
}
async SendOTP() {
  if (!this.validator.allValid()) {
    this.validator.showMessages();
    // rerender to show messages for the first time
    // you can use the autoForceUpdate option to do this automatically`            
    this.forceUpdate();            
  }else if(this.state.RePassword!=this.state.newPassword){  
    this.setState({errorAt:true});
  }else{
 
    return await axios({
     method: 'get',
       url: api.HOST+SEND_OTP,           
       headers: {
         'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
         'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
       },        
     })
    .then((result) => {
        this.setState({
          status:result,
          OtpReference:result.data.otpRef,
        });

        if(result.data.otpCode){
          this.setState({
            ConfirmOTP:true,
          });
        }
        return result;
    }).catch ((err)=>{
      console.log('Login Fail : ' +err)
   // this.status(err);    
     console.log("errr  : status : "+err.response.status);

   });
  }
}

async ResendOTP() {

   return await axios({
     method: 'get',
       url: api.HOST+RESEND_OTP+this.state.OtpReference,           
       headers: {
         'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
         'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
       },        
     })
    .then((result) => {
        this.setState({
          OtpReference: result.data.otpRef,
          //dataSource: result.fdList,
        });
        return result;
    }).catch((error)=> {
      console.log(error);
  })
  }

  async ChangePasswordAPI() {
    console.log("Hit"+this.state.NewPassword)
     var newPass= encodeURIComponent(this.state.newPassword);
     var oldPass = encodeURIComponent(this.state.oldPassword) ;   
     var U_Name = JSON.parse(sessionStorage.getItem("userId")).id;
       return await axios({
           method: 'get',
           url: api.HOST+CHANGE_PASSWORD+this.state.EnteredOTP+'&userId='+U_Name+'&oldPwd='+oldPass+'&newPwd='+newPass+'&otpRef='+this.state.OtpReference,           
           headers: {
             'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
             'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
           },        
         })        
       .then((result) => {
           this.setState({
             Status:result.data.status,
           });
           if(result.data.status=="SUCCESS"){
             this.setState({
               ConfirmOTP:false,
               Successpop:true,
             });
           }else if(result.data.status=="UNSUCCESS"){
             this.setState({
               Unsuccesspop:true,
               errorAt:true,               
             });
           }else if(result.data.status=="TRIALS"){
             this.setState({
               Trials:true,
               errorAt:true,               
             });
           }else if(result.data.status=="INVALID"){
             this.setState({
               Invalid:true,
               errorAt:true,               
             });
           }else if(result.data.status=="EXPIRY"){
             this.setState({
               Expire:true,
               errorAt:true,               
             });
           }else if(result.data.status=="NOT MATCH"){
             this.setState({
               NotMatch:true,
               errorAt:true,
             });
           }
           return result;
       }).catch ((err)=>{
        console.log('Login Fail : ' +err.response.description)
     });     
   }
setShowPassword () {
  this.setState({ShowPassword:true});
    setTimeout(() => {
        this.setState({ShowPassword:false});
      }, 900);
}
setShowPassword2 (){
  this.setState({ShowPassword2:true});
    setTimeout(() => {
      this.setState({ShowPassword2:false});
      }, 900);
    }
  setShowPassword3 (){
    this.setState({ShowPassword3:true});
      setTimeout(() => {
        this.setState({ShowPassword3:false});
        }, 900);
      }
ChangePassword(){   
  return (

      <Modal
        show={this.state.Changepw}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered 
        backdrop="static"
        onHide={()=>this.setState({Changepw:false})}
      >
        <Modal.Header closeButton>
          <Modal.Title  id="contained-modal-title-vcenter">
            <p className='modal-head-f'>CHANGE</p><br/>PASSWORD            
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>                
          <Form > 
              <Form.Group as={Row} className="mb-1 margintop-f">
              <p className='highlight-txt'> 
                Please note that Passwords are case sensitive
                 password should contain 8 characters with at least 1 digit and 1 letter
              </p>
                  <Form.Label className="c-font" column sm={5}>
                      Old Password
                  </Form.Label>
                  <Col sm={7} >
                  <div className="pass-wrapper">
                  <Form.Control maxLength={8} value={this.state.oldPassword} onChange={(e)=>this.setState({oldPassword:e.target.value})} className="form-h2" size="sm" type={this.state.ShowPassword?"text":"password"} placeholder="Old Password" />
                  <ieshow className="ieshow" onClick={()=>{this.setShowPassword()}} >{eye}</ieshow>
                  </div>
                  <p className='vali-txt'>{this.validator.message('Old Password', this.state.oldPassword, 'required')}</p>
                  </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-1 margintop-f">
                  <Form.Label className="c-font" column sm={5}>
                    New Password
                  </Form.Label>
                  <Col sm={7} >
                  <div className="pass-wrapper">
                  <Form.Control maxLength={8} value={this.state.newPassword}  onChange={(e)=>this.setState({newPassword:e.target.value})} className="form-h2" size="sm" type={this.state.ShowPassword2?"text":"password"} placeholder="New Password" />
                  <ieshow className="ieshow" onClick={()=>{this.setShowPassword2()}}>{eye}</ieshow>
                  </div>
                  <p className='vali-txt'>{this.validator.message('New Password', this.state.newPassword, 'required')}</p>
                  </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-1 margintop-f">
                  <Form.Label className="c-font" column sm={5}>
                   Re-Type New Password
                  </Form.Label>
                  <Col sm={7} >
                  <div className="pass-wrapper">
                  <Form.Control maxLength={8} value={this.state.RePassword} onChange={(e)=>this.setState({RePassword:e.target.value})} className="form-h2" size="sm" type={this.state.ShowPassword3?"text":"password"} placeholder="Re-Type New Password" />
                  <ieshow className="ieshow" onClick={()=>{this.setShowPassword3()}} >{eye}</ieshow>
                  </div>
                  <p className='vali-txt'>{this.validator.message('Re-Type password', this.state.RePassword, 'required')}</p>                  
                  </Col>
              </Form.Group>
              
          </Form>
        </Modal.Body>
        <Modal.Footer>                
          <Button className="btn-logout" onClick={()=>this.SendOTP()}>Change Password</Button>
        </Modal.Footer>
      </Modal>
    );
}
onNavbarToggle =() =>{  
  
}
onNavbarToggle2 =(e) =>{  
  e=true;
  return this.setState({ 
    activeState:!e,
    activeState2:e,    
  });
}

handleNavToggle = (e) => {
  this.setState({
    toggle:true,
  })
}

handleCanvasClose = (e) => {
  this.setState({
    toggle:false,
  })
}


render(){

    return (
      
      <Navbar activeClassName="active" className="sfam-navbar" variant="light" expand="lg">
        <Container>
        <OTPModal ConfirmOTP={this.state.ConfirmOTP} ResendOTP={()=>this.ResendOTP()}
        setConfirmOTP={()=>this.setState({ ConfirmOTP:false})} Confirm={()=>this.ChangePasswordAPI()}
        EnteredValue={e=>this.setState({EnteredOTP:e.target.value})} />
        
            { this.state.Successpop?
                <SweetAlert success btnSize='lg' confirmBtnBsStyle='success' title="SUCCESSFUL" 
                onConfirm={()=>{this.setState({Successpop:false,Changepw:false,ComPopup:true})}}>
                  <div>
                    SUCCESSFULLY CHANGED PASSWORD!<br/>
                  Logout and login with new password
                  </div>
                </SweetAlert>:null
            }
          {this.state.errorAt?
            <SweetAlert warning btnSize='lg' confirmBtnBsStyle='success' title="Error" onConfirm={()=>this.setState({errorAt:false})} >
              
              { this.state.Unsuccesspop?
                    <div>
                        Contact <br/>
                        Phone: +94 112 301301<br/>
                         Email: senk@senfin.com<br/> 
                        267, Galle Road, Colombo 03, Sri Lanka
                    </div>
                    : this.state.Trials?  
                    <div>
                        Trial more than three times<br/>
                        Contact <br/>
                        Phone: +94 112 301301<br/>
                         Email: senk@senfin.com <br/> 
                        267, Galle Road, Colombo 03, Sri Lanka
                    </div>
                  : this.state.Invalid?
                  "Enter Correct OTP"
                  :this.state.Expire?
                  "Expired OTP. Try With Resend OTP"
                  :this.state.NotMatch?
                  "Enter Correct old password"
                  :this.state.newPassword.match(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)/)?
                  <div>Please note that Passwords are case sensitive
                    password should contain 8 characters with at least 1 digit and 1 letter"
                  </div>
                  :"Password and Re-type password not matched"
              }
            </SweetAlert>
            :
            null
          }
          <LinkContainer  className="nav-pad" to="/Home">
            <Navbar.Brand >
              <div className="login-area h-bottoms hmargin-left">
                  <img className='logo' alt="Senfin" src={logo} />
                  <div className='block-header' >
                   <h5>SENFIN ONLINE PORTAL </h5>                        
                  </div>  
              </div>
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle onClick={(e) => this.handleNavToggle()} />
          <Offcanvas className="canvas-custom" style={{width:'50%'}} show={this.state.toggle} onHide={(e) => this.handleCanvasClose()} placement="start">
            <Offcanvas.Header style={{paddingBottom:0, fontSize:12}}>
              <Offcanvas.Title style={{display:'flex'}}>
                    <img className="profile-img d-flex align-items-end" 
                      onClick={() => { this.setState({ProfilePopup:true})}} 
                      src={profile}   />
                      <div className='div-m'>
                        {this.UserProfile()}
                        <p  style={{textAlign:'left'}} className='c-font5'>
                        {getUD.UserFirstname}  {" "+getUD.UserLastname}
                        </p>
                        <p style={{textAlign:'left'}} className='c-font4 margintop-f2'>                    
                        Last Login : {moment(getUD.previousLogin).format('DD/MM/YYYY')
                        +" "+moment(getUD.previousLogin).format('hh:mm:ss A')}</p>                   
                      </div>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <hr/>
            <Offcanvas.Body style={{display:"flex", flexDirection:'column', justifyContent:'space-between'}}>
              <div>
              <LinkContainer to="/Home" onClick={() =>  this.setState({activeState:true,activeState2:false})}  activeClassName="active2 img1" className='white-font canvas-box'>
                  <Nav.Link eventKey={1} className="">
                    <div  className='d-flex flex-column justify-content-center'>
                      <p className='h-text'>HOME</p>
                    </div>                 
                  </Nav.Link>
                </LinkContainer>
                <LinkContainer to="/Savings"  onClick={this.props.saveonclick}  activeClassName="active2 img2" className='white-font canvas-box'   disabled={sessionStorage.getItem("active") != 'null'?'':true}>
                  <Nav.Link  eventKey={2}>                 
                    <div className='d-flex flex-column justify-content-center'>              
                      <p className='h-text '>SAVINGS</p>
                    </div>
                  </Nav.Link>
                </LinkContainer>
                <LinkContainer to="/FixedDeposit" onClick={this.props.fdonclick} activeClassName="active2" className='white-font canvas-box'>                  
                  <Nav.Link eventKey={3} className="">
                    <div className='d-flex flex-column justify-content-center'>
                      <p className='h-text2'>DEPOSITS</p>
                    </div>
                  </Nav.Link>
                </LinkContainer>
                <LinkContainer  to="/Pawning" activeClassName="active2" className='white-font canvas-box'>
                  <Nav.Link  eventKey={4} className="">
                    <div className='d-flex flex-column justify-content-center'>
                        <p className='h-text'>PAWNING</p>
                    </div>
                  </Nav.Link>
                </LinkContainer>
                <LinkContainer to="#" activeClassName="active2" className='canvas-box white-font '>
                  <Nav.Link  eventKey={1} className="">
                    <div  className='d-flex flex-column justify-content-center'>
                      <p className='h-text'>LEASES</p>
                    </div>
                  </Nav.Link>
                </LinkContainer>
                </div>
                <div>
                {this.ChangePassword()}  
                <LinkContainer to="#" onClick={() => {
                    this.setState({
                      Changepw:true,
                    })
                  }} activeClassName="active2" className='canvas-box white-font'>
                    <Nav.Link  eventKey={1} className="">
                      <div  className='d-flex flex-column justify-content-center'>
                        <p className='h-text'>Change Password</p>
                      </div>
                    </Nav.Link>
                  </LinkContainer>

                {this.ConfirmationPopUp()}
                  <LinkContainer to="#" onClick={() => {
                    this.setState({
                      ComPopup:true,
                    })
                  }} activeClassName="active2" className='canvas-box white-font'>
                    <Nav.Link  eventKey={1} className="">
                      <div  className='d-flex flex-column justify-content-center'>
                        <p className='h-text'>Sign Out</p>
                      </div>
                    </Nav.Link>
                  </LinkContainer>
                </div>
            </Offcanvas.Body>
          </Offcanvas>
          <Navbar.Collapse className='nav-hidden' id="basic-navbar-nav">
            <Nav className="me-auto"></Nav>
            <Nav  className="me-auto d-flex flex-row ">
            <Row className='d-flex flex-row flex-wrap align-items-center fade-parent'>                
              <Col sm={2} className="fade-item">
              <LinkContainer to="/Home" onClick={() =>  this.setState({activeState:true,activeState2:false})}  activeClassName="active2 img1" className='white-font header-box '>
                <Nav.Link eventKey={1} className="" >
                  <div  className='d-flex flex-column justify-content-center zoom'>
                    <img className='hlogo' alt="Senfin" src={home} />
                    <p className='h-text' style={{fontWeight:'300'}}>HOME</p>
                  </div>                 
                </Nav.Link>
              </LinkContainer>
              </Col>
              <Col sm={2} className="fade-item">
              <LinkContainer to="/Savings"  onClick={this.props.saveonclick}  activeClassName="active2 img2" className='white-font header-box2'   disabled={sessionStorage.getItem("active") != 'null'?'':true}>
                <Nav.Link  eventKey={2} className=""  >                 
                  <div className='d-flex flex-column justify-content-center zoom'>
                    <img className='hlogo' alt="Senfin" src={save} />                      
                    <p className='h-text' style={{fontWeight:'300'}}>SAVINGS</p>
                  </div>
                </Nav.Link>
              </LinkContainer>
              </Col>
              <Col sm={2} className="fade-item">
              <LinkContainer to="/FixedDeposit" onClick={this.props.fdonclick} activeClassName="active2" className='white-font header-box2'>                  
                <Nav.Link eventKey={3} className="">
                  <div className='d-flex flex-column justify-content-center zoom'>
                    <img className='hlogo' alt="Senfin" src={fd} />
                    <p className='h-text2' style={{fontWeight:'300'}}>DEPOSITS</p>
                  </div>
                </Nav.Link>
              </LinkContainer>
              </Col>
              <Col sm={2} className="fade-item">
              <LinkContainer  to="/Pawning" activeClassName="active2" className='white-font header-box2 '>
                <Nav.Link  eventKey={4} className="">
                  <div className='d-flex flex-column justify-content-center '>
                    <img className='hlogo' alt="Senfin" src={pawn} />
                      <p className='h-text' style={{fontWeight:'300'}}>PAWNING</p>
                  </div>
                </Nav.Link>
              </LinkContainer>
              </Col>
              <Col sm={2} className="fade-item">
              <LinkContainer to="#" activeClassName="active2" className='header-box3 white-font '>
                <Nav.Link  eventKey={1} className="">
                  <div  className='d-flex flex-column justify-content-center'>
                    <img className='hlogo' alt="Senfin" src={lease} />
                    <p className='h-text' style={{fontWeight:'300'}}>LEASES</p>
                  </div>
                </Nav.Link>
              </LinkContainer>
              </Col>
            </Row>                
            </Nav>
            <Nav  className="nav-pad d-flex align-items-end justify-content-end ">
              <Row className="h-top d-flex align-items-center justify-content-end">  
                <Col  lg={7}>
                    <div className='div-m'>
                      {
                        getUD.customerIdType == 3?
                        <p className='c-font5'>
                        {getUD.companyName}
                        </p>
                        :
                        <p className='c-font5'>
                        {getUD.UserFirstname}  {" "+getUD.UserLastname}
                        </p>
                      }
                      
                      <p className='c-font4 margintop-f2'>                    
                      Last Login : {moment(getUD.previousLogin).format('DD/MM/YYYY')
                      +" "+moment(getUD.previousLogin).format('hh:mm:ss A')}</p>                   
                    </div>    
                  <NavDropdown 
                  title={
                      <span className="sign-out-t">Sign Out</span>
                    } 
                  className="sign-out text-color"  
                  id="basic-nav-dropdown">
                    <LinkContainer to="#" disabled={sessionStorage.getItem("active") != 'null'?'':true}>
                      <NavDropdown.Item   className="text-color" onClick={() => { this.setState({Changepw:true})}}>Change Password</NavDropdown.Item>
                    </LinkContainer>
                    {/* <NavDropdown.Item href="#action/3.2">Settings</NavDropdown.Item> */}
                    <NavDropdown.Divider />
                    {this.ChangePassword()}  
                                        
                    {this.ConfirmationPopUp()}
                    <NavDropdown.Item className="text-color" href="" onClick={() => { this.setState({ComPopup:true})}}>Sign Out</NavDropdown.Item>
                  </NavDropdown>
                </Col>                
                <Col  sm={5}>
                  <img className="profile-img d-flex align-items-end" 
                  onClick={() => { this.setState({ProfilePopup:true})}} 
                  src={profile}   />
                  {this.UserProfile()}
                </Col>                  
              </Row>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      );  
  }
}
export default Header;
